<template>
  <div id="payerManage">
    <header-nav :content="`${$t('pages_router_007')} / ${ $t('pages_router_035')}`" />
    <div class="common-card-body">
      <div class="flex-align">
        <div class="payer-header" @click="$router.push('/funds/outbounds')">
          <left-outlined class="ic-back" />
          {{ $t('pages_pay_191') }}
        </div>
        <div class="edit-btn">
          <a-button shape="round" style="background-color: rgba(186, 132, 56, 0.1);color: #BA8438;border:0px" @click="$router.push('/funds/payerC2C_edit')">
            <template #icon><plus-outlined /></template>
            {{ $t('pages_pay_256') }}
          </a-button>
        </div>
      </div>
      <div class="search-form ant-round-form">
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_376') }}: </span>
          <a-select
            v-model:value="searchQuery.payerCountry"
            allow-clear
            show-search
            option-filter-prop="label"
            @change="loadPayerList(1)"
          >
            <a-select-option
              v-for="item in outboundCountries"
              :key="item.id"
              :value="item.areaCode"
              :label="`${item.country} - ${item.countryChineseName}`"
            >
              <span>{{ item.country }} - {{ item.countryChineseName }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_377') }}: </span>
          <a-input
            v-model:value="searchQuery.payerFirstName"
            allow-clear
            @pressEnter="loadPayerList(1)"
            @blur="loadPayerList(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_378') }}: </span>
          <a-input
            v-model:value="searchQuery.payerLastName"
            allow-clear
            @pressEnter="loadPayerList(1)"
            @blur="loadPayerList(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_379') }}: </span>
          <a-input
            v-model:value="searchQuery.identificationNumber"
            allow-clear
            @pressEnter="loadPayerList(1)"
            @blur="loadPayerList(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_381') }}: </span>
          <a-input
            v-model:value="searchQuery.contactNumber"
            allow-clear
            @pressEnter="loadPayerList(1)"
            @blur="loadPayerList(1)"
          />
        </div>
        <div class="part flex-align">
          <span class="part-label">{{ $t('pages_pay_382') }}: </span>
          <a-input
            v-model:value="searchQuery.emailAddress"
            allow-clear
            @pressEnter="loadPayerList(1)"
            @blur="loadPayerList(1)"
          />
        </div>
      </div>
      <div class="table-part">
        <a-table
          :scroll="{ x: 1200 }"
          :loading="loading"
          :pagination="false"
          :custom-header-row="() => { return {class: 'my-table-tr'}}"
          :columns="columns"
          :data-source="payers"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'edit'">
              <a-space style="width: 100%;">
                <a-button
                  size="small"
                  type="text"
                  style="color: #ba8438;"
                  @click="$router.push({ path: '/funds/payerC2C_edit', query: { payerId: record.id, type: 'detail' }})"
                >{{ $t('pages_pay_119') }}</a-button>
                <a-button
                  v-if="record.status!=='01'"
                  size="small"
                  type="link"
                  @click="$router.push({ path: '/funds/payerC2C_edit', query: { payerId: record.id, type: 'update' }})"
                >{{ $t('pages_pay_199') }}</a-button>
                <!-- <a-button
                  shape="round"
                  size="small"
                  type="primary"
                  style="margin-left: 5px"
                  @click="toPay(record.id)"
                >{{ $t('pages_pay_191') }}</a-button> -->
              </a-space>
            </template>
          </template>
        </a-table>
        <table-page
          :total="total"
          :page-opts="searchQuery"
          @update-page="updatePage"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, toRefs } from 'vue'
import HeaderNav from '@/components/header-nav'
import TablePage from '@/components/table-page'
import { useRouter } from 'vue-router'
import { _pay } from '@/api'
import { getCountryName, getTradeStatusName, getAreaList } from '@/util'
import { message } from 'ant-design-vue'
import i18n from '@/locale'
export default {
  name: 'PayerC2CManage',
  components: {
    'header-nav': HeaderNav,
    'table-page': TablePage
  },
  setup () {
    const payerEditRef = ref(null)
    const router = useRouter()
    const state = reactive({
      loading: false,
      visible: false,
      exportLoading: false,
      searchQuery: {
        pageNo: 1,
        pageSize: 10,
        id: '',
        payerFirstName: '',
        payerLastName: ''
      },
      total: 0,
      areas: [],
      outboundCountries: [],
      areaPubList: [],
      payers: [],
      columns: [
        { key: 'payerCountry', dataIndex: 'payerCountry', title: i18n.global.t('pages_pay_376'), width: 200, ellipsis: true },
        { key: 'payerFirstName', dataIndex: 'payerFirstName', title: i18n.global.t('pages_pay_377'), ellipsis: true },
        { key: 'payerLastName', dataIndex: 'payerLastName', title: i18n.global.t('pages_pay_378'), ellipsis: true },
        { key: 'identificationNumber', dataIndex: 'identificationNumber', title: i18n.global.t('pages_pay_379'), ellipsis: true },
        { key: 'contactNumber', dataIndex: 'contactNumber', title: i18n.global.t('pages_pay_381'), ellipsis: true },
        { key: 'emailAddress', dataIndex: 'emailAddress', title: i18n.global.t('pages_pay_382'), ellipsis: true },
        { key: 'status', dataIndex: 'statusText', title: i18n.global.t('pages_pay_114'), ellipsis: true, width: 120 },
        { key: 'remark', dataIndex: 'remark', title: i18n.global.t('pages_pay_118'), ellipsis: true },
        { key: 'edit', title: i18n.global.t('common_text_001'), fixed: 'right', width: localStorage.getItem('locale-language') === 'en' ? 350 : 200 }
      ]
    })

    const updatePage = (page, pageSize) => {
      state.searchQuery.pageNum = page
      state.searchQuery.pageSize = pageSize
      loadPayerList()
    }

    const updatePayer = async (id) => {
      if (id) {
        const res = await _pay.getPayerDetail({ id })
        if (res.data.succ) {
          const data = Object.assign({}, res.data.data, {
            certNo: res.data.data.identityNo
          })
          payerEditRef.value.intParams(data, true)
          state.visible = true
        }
      } else {
        payerEditRef.value.intParams({}, false)
        state.visible = true
      }
    }

    const deletePayer = (id) => {
      _pay.removePayer({ id })
        .then(res => {
          message.success(i18n.global.t('pages_pay_203'))
          handleRefresh()
        })
        .catch(err => console.log(err))
    }

    const toPay = (payerId) => {
      const query = { payerId }
      router.push({ path: '/funds/inbounds/single_cny', query })
    }
    const handleRefresh = () => {
      loadPayerList()
      loadPayerNameList()
    }

    const loadPayerNameList = async () => {
      const res = await _pay.getOutboundsCountries()
      if (res.data.succ) {
        state.outboundCountries = res.data.data
      }
    }

    const loadAreaList = async () => {
      const res = await _pay.getRegionList()
      if (res.data.succ) state.areas = res.data.data
    }

    const loadPayerList = async (pageNum) => {
      state.loading = true
      if (pageNum) state.searchQuery.pageNum = pageNum
      const query = Object.assign({}, state.searchQuery, {
        pageNo: state.searchQuery.pageNum
      })
      delete query.pageNum
      const res = await _pay.payerInfoQueryByPage(state.searchQuery)
      if (res.data.succ) {
        state.payers = res.data.data.list.map(item => {
          return Object.assign({}, item, {
            payerCountry: `${getCountryName(item.payerCountry, state.areaPubList)}` || '-',
            statusText: getTradeStatusName(item.status, 'payeeStatus')
          })
        })
        state.total = res.data.data.total
      }
      console.log(state.payers, 'state.payers')
      state.loading = false
    }
    const loadAreaPub = async () => {
      state.areaPubList = getAreaList()
    }
    loadAreaPub()
    loadAreaList()
    loadPayerList()
    loadPayerNameList()

    return {
      payerEditRef,
      updatePage,
      updatePayer,
      deletePayer,
      loadAreaPub,
      toPay,
      handleRefresh,
      loadPayerList,
      loadAreaList,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#payerManage {
  text-align: left;
  .common-card-body {
    padding: 24px;
    .payer-header {
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      .ic-back {
        color: @main-color;
      }
    }
    .edit-btn {
      margin-left: auto;
    }
    .edit-btn:deep(.ant-btn) {
      min-width: 135px;
    }
    .part {
      flex: 0 0 38%;
      .part-label {
        width: 200px;
      }
    }
    .table-part {
      margin: 12px -24px 0 -24px;
      .circle-person, .circle-company {
        width: 6px;
        height: 6px;
        background: @success-color;
        margin-right: 8px;
        border-radius: 50%;
      }
      .circle-company {
        background: @main-color;
      }
    }
  }
}
</style>
